import request from "@/api";

export function listPosition(data) {
    return request({
        url: '/api/position/getPositionList',
        method: 'get',
        params: data
    })
}
export function savePosition(data) {
    return request({
        url: '/api/position/savePosition',
        method: 'post',
        data: data
    })
}

export function deletePosition(data) {
    return request({
        url: '/api/position/deletePosition',
        method: 'post',
        data: data
    })
}
